import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle: React.FC = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="language-toggle"
      style={{
        background: 'var(--color-bg-soft-warm)',
        border: 'none',
        borderRadius: '30px',
        padding: '11px 16px',
        cursor: 'pointer',
        fontSize: '13px',
        fontWeight: '600',
        color: 'var(--color-text-secondary)',
        transition: 'all 0.2s ease',
        minWidth: '80px',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-text-primary)';
        e.currentTarget.style.color = 'var(--color-bg-base)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--color-bg-soft-warm)';
        e.currentTarget.style.color = 'var(--color-text-secondary)';
      }}
    >
      {language === 'en' ? '한국어' : 'English'}
    </button>
  );
};

export default LanguageToggle;